import { useTranslation } from 'react-i18next'

import { CheckCircleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Alert, Switch, Text } from '@reveni-io/reveni-ui'

import ManageRestock from '@/returns/components/ManageRestock/ManageRestock'

import * as Styles from '../styles'

const AmendRejectedOptions = ({
  amendedCount,
  totalCount,
  allowManageRestock,
  restockValue,
  onChangeRestock,
  locations,
  selectedLocation,
  onChangeLocation,
  provider,
  storeId,
  notifyCustomer,
  onChangeNotifyCustomer,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasAmendedItems = amendedCount > 0

  const getCounterText = () => {
    if (!hasAmendedItems) return t('0 productos corregidos')

    return t('{{amended}} de {{total}} productos corregidos', { amended: amendedCount, total: totalCount })
  }

  return (
    <>
      <Styles.CounterContainer>
        <CheckCircleIcon size={20} color={theme.colors.success.onSurface} />
        <Text type="bodyMBold">{getCounterText()}</Text>
      </Styles.CounterContainer>
      {hasAmendedItems && (
        <>
          {allowManageRestock && (
            <ManageRestock
              value={restockValue}
              onChange={onChangeRestock}
              locations={locations}
              selectedLocation={selectedLocation}
              onChangeLocation={onChangeLocation}
              provider={provider}
              storeId={storeId}
              title={t('Reposición de productos:')}
              restockLabel={t('Reponer productos corregidos')}
              noRestockLabel={t('Dejar productos corregidos sin reponer')}
            />
          )}
          <Styles.NotifyContainer>
            <Switch label={t('Notificar al cliente')} checked={notifyCustomer} onChange={onChangeNotifyCustomer} />
          </Styles.NotifyContainer>
          <Alert type="warning">{t('Esta acción no se puede deshacer. ¿Quieres continuar?')}</Alert>
        </>
      )}
    </>
  )
}

export default AmendRejectedOptions
